import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';
import { getCheShi } from '../../../../../services/api';
import Title from '../../../components/title';
import SubTitle from '../../../components/subtitle';
import Citys from '../../../components/citys';
// import MarketCitys from './marketCitys';
import PropTypes from 'prop-types';

class Market extends React.PureComponent {
    static propTypes = {
        curCity: PropTypes.object,
        citysData: PropTypes.object,
    };
    state = {
        cheshiAllData: {},
        chenShiData: {},
        type: ['猜你喜欢', '10万以下', '10-20万', '20-30万', '30-50万', '50万以上', 'SUV', '综合'],
        hoverIndex: 0,
    };

    static getDerivedStateFromProps(props, state) {
        // Any time the current user changes,
        // Reset any parts of state that are tied to that user.
        // In this simple example, that's just the email.
        // if (props.userID !== state.prevPropsUserID) {
        //   return {
        //     prevPropsUserID: props.userID,
        //     email: props.defaultEmail
        //   };
        // }

        return null;
    }

    async componentDidMount() {
        if (this.props.curCity) {
            this.setState({
                curCity: this.props.curCity,
            });
        }
        try {
            let chenShiData = await getCheShi(
                this.props.curCity.citypinyin ? this.props.curCity.citypinyin : 'beijing',
                1,
            );

            let chenShiAllData = Object.assign(this.state.cheshiAllData, { type1: chenShiData });

            this.setState({
                chenShiData,
                chenShiAllData,
            });
        } catch (e) {
            console.error(e);
        }
    }

    containerMouseEnterHandle = hoverIndex => {
        this.setState({
            hoverIndex,
        });

        const cheshiIndex = `type${hoverIndex + 1}`;

        if (this.state.cheshiAllData[cheshiIndex]) {
            this.setState({
                chenShiData: this.state.cheshiAllData[cheshiIndex],
            });
        } else {
            this.getCheShiData(
                this.props.curCity.citypinyin ? this.props.curCity.citypinyin : 'beijing',
                hoverIndex + 1,
            );
        }
    };

    getCheShiData = async (citypy, typeid) => {
        let chenShiData = await getCheShi(citypy, typeid);

        let chenShiAllData = Object.assign(this.state.cheshiAllData, { [`type${typeid}`]: chenShiData });

        this.setState({
            chenShiData,
            chenShiAllData,
        });
    };
    /**
     * 渲染组件
     */
    createChannelInfo = () => {
        for (let key in this.state.chenShiData.ad2) {
            if (key === 'data') {
                return { __html: this.state.chenShiData.ad2[key] };
            }
        }
    };

    render() {
        const { citysData, curCity } = this.props;
        const { type, chenShiData, hoverIndex } = this.state;

        return (
            <div className={styles.market}>
                <Title content={`${curCity.cityname}车市`} />
                <div className={styles.citys}>
                    {curCity && citysData && citysData.cityData && citysData.cityData.length > 0 ? (
                        <Citys citysData={citysData} curCity={curCity} />
                    ) : (
                        ''
                    )}
                </div>
                <div className={styles.column}>
                    <div className={styles.car_market}>
                        <div className={styles.cm_tag}>
                            {type.map((item, index) => (
                                <span
                                    key={index}
                                    className={hoverIndex === index ? styles.on : ''}
                                    onMouseEnter={this.containerMouseEnterHandle.bind(this, index)}
                                    onMouseLeave={this.containerMouseLeaveHandle}>
                                    {item}
                                </span>
                            ))}
                        </div>
                        <div dangerouslySetInnerHTML={this.createChannelInfo()} />

                        <div className={styles.cm_item}>
                            <div className={styles.col_con_l}>
                                <ul className={styles.cm_table}>
                                    <li className={styles.tit}>
                                        <span className={styles.s1}>车系</span>
                                        <span className={styles.s2}>最高降幅</span>
                                        <span className={styles.s3}>优惠价</span>
                                        <span className={styles.s4}>经销商</span>
                                    </li>
                                    {chenShiData.left &&
                                        chenShiData.left.priceNewItemList &&
                                        chenShiData.left.priceNewItemList.map((item, index) => (
                                            <li key={index}>
                                                <span className={styles.s1}>
                                                    <a
                                                        href={`//dealer.auto.ifeng.com/${item.did}/price_serial_${
                                                            item.serialId
                                                        }.html#${item.serialId}`}
                                                        target="_blank"
                                                        rel={rel}>
                                                        {item.standardName}
                                                    </a>
                                                </span>

                                                {item.mainComparePrice > 0 ? (
                                                    <span className={styles.s2}>
                                                        <span className={styles.n}>↓{item.mainComparePrice}</span> 万{' '}
                                                    </span>
                                                ) : (
                                                    <span className={styles.s2}>
                                                        <span>/</span>
                                                    </span>
                                                )}

                                                <span className={styles.s3}>
                                                    <span className={styles.n}>{item.mainPrice}</span>万起
                                                </span>
                                                <span className={styles.s4}>
                                                    <a
                                                        href={`//dealer.auto.ifeng.com/${item.did}/`}
                                                        target="_blank"
                                                        rel={rel}>
                                                        {item.coaName}
                                                    </a>
                                                    <a
                                                        href={`//dealer.auto.ifeng.com/${item.did}/ask.html`}
                                                        target="_blank"
                                                        rel={rel}
                                                        className={styles.enq}>
                                                        [询价]
                                                    </a>
                                                </span>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                            <div className={styles.col_con_m}>
                                <div className={styles.img_b}>
                                    <a href="#" target="_blank">
                                        <img
                                            src="https://a0.ifengimg.com/autoimg/serial/500/10499_3.png"
                                            alt="图片对应问题标题或者品牌车系车型"
                                        />
                                    </a>
                                    <div className={styles.imgt}>别克于2012年开始生产昂科拉小型跨界车</div>
                                    <div className={styles.imgm} />
                                </div>
                                <div className={styles.img_b_s}>
                                    <span>
                                        原价:<span className={styles.r}>8.2</span>万
                                    </span>
                                    <span>
                                        降价:<span className={styles.g}>↓4</span>万
                                    </span>
                                </div>
                                <ul className={styles.brand_ul}>
                                    {chenShiData.left &&
                                        chenShiData.left.dealerInfoItemNew &&
                                        chenShiData.left.dealerInfoItemNew.map((item, index) => (
                                            <li key={index}>
                                                <a className={styles.li_img}>
                                                    <img src={item.logoUrl} alt="图片对应问题标题或者品牌车系车型" />
                                                </a>
                                                <div className={styles.li_img_t}>
                                                    <span className={styles.li_imgt_t}>
                                                        {item.coaName}
                                                        <span>{item.is400 > 0 ? '4S' : ''}</span>
                                                    </span>

                                                    {item.tell400Show && item.tell400s ? (
                                                        <span className={styles.li_imgt_p}>
                                                            {item.tell400Show.slice(0, 3)}-{item.tell400Show.slice(
                                                                3,
                                                                6,
                                                            )}-{item.tell400Show.slice(6, item.tell400Show.length)}
                                                            转 {item.tell400s}
                                                        </span>
                                                    ) : (
                                                        <span className={styles.li_imgt_p}>{item.telSale}</span>
                                                    )}
                                                </div>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                            <div className={styles.col_con_r}>
                                <ul>
                                    <li>
                                        <div className={styles.cm_tit}>
                                            <span className={styles.t}>降价</span>
                                            <span className={styles.m}>
                                                <a
                                                    href={`//auto.ifeng.com/${curCity.citypinyin}/jiangjia/`}
                                                    target="_blank"
                                                    rel="nofollow">
                                                    更多
                                                </a>&gt;
                                            </span>
                                        </div>
                                        <div className={styles.img_b}>
                                            {chenShiData.redPrice && chenShiData.redPrice.length > 0 ? (
                                                <a
                                                    className={styles.img}
                                                    href={chenShiData.redPrice[0].url}
                                                    target="_blank"
                                                    rel={rel}>
                                                    <img
                                                        ifengsrc={chenShiData.redPrice[0].thumb}
                                                        src={chenShiData.redPrice[0].thumb}
                                                        alt={chenShiData.redPrice[0].title}
                                                    />
                                                    <div className={styles.imgt}>
                                                        <span>{chenShiData.redPrice[0].title}</span>
                                                    </div>
                                                    <div className={styles.imgm} />
                                                </a>
                                            ) : (
                                                ''
                                            )}

                                            <ul className={styles.img_ul}>
                                                {chenShiData.redPrice &&
                                                    chenShiData.redPrice.length > 1 &&
                                                    chenShiData.redPrice
                                                        .filter((item, index) => index >= 1 && index <= 3)
                                                        .map((item, index) => (
                                                            <li key={index}>
                                                                <a href={item.url} target="_blank" rel={rel}>
                                                                    {item.short_title ? item.short_title : item.title}
                                                                </a>
                                                            </li>
                                                        ))}
                                            </ul>
                                        </div>
                                    </li>
                                    <li>
                                        <div className={styles.cm_tit}>
                                            <span className={styles.t}>导购</span>
                                            <span className={styles.m}>
                                                <a
                                                    href={`//${curCity.citypinyin}.auto.ifeng.com/daogou/`}
                                                    target="_blank"
                                                    rel={rel}>
                                                    更多
                                                </a>&gt;
                                            </span>
                                        </div>
                                        <div className={styles.img_b}>
                                            {chenShiData.guide && chenShiData.guide.length > 0 ? (
                                                <a
                                                    className={styles.img}
                                                    href={chenShiData.guide[0].url}
                                                    target="_blank"
                                                    rel={rel}>
                                                    <img
                                                        ifengsrc={chenShiData.guide[0].thumb}
                                                        src={chenShiData.guide[0].thumb}
                                                        alt={chenShiData.guide[0].title}
                                                    />
                                                    <div className={styles.imgt}>
                                                        <span>{chenShiData.guide[0].title}</span>
                                                    </div>
                                                    <div className={styles.imgm} />
                                                </a>
                                            ) : (
                                                ''
                                            )}
                                            <ul className={styles.img_ul}>
                                                {chenShiData.guide &&
                                                    chenShiData.guide.length > 1 &&
                                                    chenShiData.guide
                                                        .filter((item, index) => index >= 1 && index <= 3)
                                                        .map((item, index) => (
                                                            <li key={index}>
                                                                <a href={item.url} target="_blank" rel={rel}>
                                                                    {item.short_title ? item.short_title : item.title}
                                                                </a>
                                                            </li>
                                                        ))}
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                                <ul className={styles.str}>
                                    <li>
                                        <div className={styles.cm_tit}>
                                            <span className={styles.t}>促销</span>
                                            <span className={styles.m}>
                                                <a
                                                    href={`https://${curCity.citypinyin}.auto.ifeng.com/xinwen/`}
                                                    target="_blank"
                                                    rel={rel}>
                                                    更多
                                                </a>&gt;
                                            </span>
                                        </div>
                                        <div className={styles.str_b}>
                                            {chenShiData.promote &&
                                                chenShiData.promote.length > 1 &&
                                                chenShiData.promote
                                                    .filter((item, index) => index >= 0 && index <= 2)
                                                    .map((item, index) => (
                                                        <a key={index} href={item.url} target="_blank" rel={rel}>
                                                            {item.title}
                                                        </a>
                                                    ))}
                                        </div>
                                    </li>
                                    <li>
                                        <div className={styles.cm_tit}>
                                            <span className={styles.t}>商情</span>
                                            <span className={styles.m}>
                                                <a
                                                    href={`https://${curCity.citypinyin}.auto.ifeng.com/shangqing/`}
                                                    target="_blank"
                                                    rel={rel}>
                                                    更多
                                                </a>&gt;
                                            </span>
                                        </div>
                                        <div className={styles.str_b}>
                                            {chenShiData.market &&
                                                chenShiData.market.length > 1 &&
                                                chenShiData.market
                                                    .filter((item, index) => index >= 0 && index <= 2)
                                                    .map((item, index) => (
                                                        <a key={index} href={item.url} target="_blank" rel={rel}>
                                                            {item.title}
                                                        </a>
                                                    ))}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Market);
